import React from 'react';

import { useDocumentVisibleOnce } from '@domains/pdp-common';

import { Shop } from '../components/Shop';
import { useSendPageViewLog } from '../log/useSendPageViewLog';
import { useShopService } from '../services/useShopService';

interface ShopContainerProps {
  className?: string;
}
export const ShopContainer: React.FC<React.PropsWithChildren<ShopContainerProps>> = ({ className }) => {
  const { ref, shouldRefetch } = useDocumentVisibleOnce({
    disableUntilScroll: true,
  });

  const {
    isZigzagApp,
    isMileageShop,
    show_placeholder_image,
    has_story,
    item,
    category_list,
    handleImageError,
    goToShopDetail,
    goToStory,
  } = useShopService({
    shouldRefetch,
  });
  const { targetRef } = useSendPageViewLog();

  return (
    <div ref={ref}>
      <Shop
        className={className}
        targetRef={targetRef}
        is_app={isZigzagApp}
        isMileageShop={isMileageShop}
        has_story={has_story}
        item={item}
        category_list={category_list}
        show_placeholder_image={show_placeholder_image}
        onImageError={handleImageError}
        goToShopDetail={goToShopDetail}
        goToStory={goToStory}
      />
    </div>
  );
};
